import { reactToAngularComponent } from './react-helpers/angular-react-helper';
import { ToastNotification } from './react-components/ToastNotification';
import HexColorPicker from './react-components/HexColorPicker';
import CollapsibleSection from './react-components/CollapsibleSection';
import AssetContainer from '../views/account/settings/asset-container';
import AssetTile from './react-components/AssetTile';
import ButtonWithPopover from './react-components/ButtonWithPopover';
import EnvelopePicker from './react-components/EnvelopePicker';
import ContactSlider from './react-components/ContactSlider';
import { OrderSummary } from './react-components/OrderSummary';
import StepIndicator from './react-components/StepIndicator';
import PackageSelectorContainer from '../views/purchase-flow/package-container';
import PackageSelector from './react-components/PackageSelector';
import IntegrationCard from './react-components/IntegrationCard';
import IntegrationContainer from '../views/account/settings/integration-container';
import VideoSolution from './react-components/VideoSolution';
import EmailPreviewTemplate from './react-components/EmailPreviewTemplate';
import LivePreview from './react-components/LivePreview';
import LandingPageOptions from './react-components/video-solution-components/LandingPageOptions';
import DatePicker from './react-components/video-solution-components/DatePicker';
import SearchBox from './react-components/video-solution-components/SearchBox';
import VideoForm from './react-components/video-solution-components/VideoForm';
import UserDropdown from './react-components/video-solution-components/UserDropdown';
import VideoList from './react-components/video-solution-components/VideoList';
import VideoButtons from './react-components/video-solution-components/VideoButtons';
import DefaultState from './react-components/video-solution-components/DefaultState';
import ThumbnailSelection from './react-components/video-solution-components/ThumbnailSelection';
import RecorderService from './react-components/video-recorder-components/RecorderService';
import MagicLink from './react-components/MagicLink';
import ListsModal from './react-components/ListsModal';
import ContactsModal from './react-components/ContactsModal';
import AiMessagePrompt from './react-components/ai-messaging-components/AiMessagePrompt';
import IconTrigger from './react-components/ai-messaging-components/IconTrigger';
import AiActionButton from './react-components/ai-messaging-components/AiActionButton';
import UsersFilter from './react-components/filter-components/UsersFilter';

angular.module('thankview.global')
    .component('toastNotification', reactToAngularComponent(ToastNotification))
    .component('hexColorPicker', reactToAngularComponent(HexColorPicker))
    .component('collapsibleSection', reactToAngularComponent(CollapsibleSection))
    .component('assetContainer', reactToAngularComponent(AssetContainer))
    .component('assetTile', reactToAngularComponent(AssetTile))
    .component('envelopePicker', reactToAngularComponent(EnvelopePicker))
    .component('contactSlider', reactToAngularComponent(ContactSlider))
    .component('orderSummary', reactToAngularComponent(OrderSummary))
    .component('stepIndicator', reactToAngularComponent(StepIndicator))
    .component('buttonWithPopover', reactToAngularComponent(ButtonWithPopover))
    .component('packageSelectorContainer', reactToAngularComponent(PackageSelectorContainer))
    .component('packageSelector', reactToAngularComponent(PackageSelector))
    .component('integrationContainer', reactToAngularComponent(IntegrationContainer))
    .component('integrationCard', reactToAngularComponent(IntegrationCard))
    .component('datePicker', reactToAngularComponent(DatePicker))
    .component('searchBox', reactToAngularComponent(SearchBox))
    .component('videoForm', reactToAngularComponent(VideoForm))
    .component('userDropdown', reactToAngularComponent(UserDropdown))
    .component('videoList', reactToAngularComponent(VideoList))
    .component('defaultState', reactToAngularComponent(DefaultState))
    .component('videoSolution', reactToAngularComponent(VideoSolution))
    .component('emailPreviewTemplate', reactToAngularComponent(EmailPreviewTemplate))
    .component('livePreview', reactToAngularComponent(LivePreview))
    .component('landingPageOptions', reactToAngularComponent(LandingPageOptions))
    .component('videoButtons', reactToAngularComponent(VideoButtons))
    .component('thumbnailSelection', reactToAngularComponent(ThumbnailSelection))
    .component('recorderService', reactToAngularComponent(RecorderService))
    .component('magicLink', reactToAngularComponent(MagicLink))
    .component('listModal', reactToAngularComponent(ListsModal))
    .component('contactModal', reactToAngularComponent(ContactsModal))
    .component('iconTrigger', reactToAngularComponent(IconTrigger))
    .component('aiPrompt', reactToAngularComponent(AiMessagePrompt))
    .component('aiActionButton', reactToAngularComponent(AiActionButton))
    .component('usersFilter', reactToAngularComponent(UsersFilter));


